<!-- 促销历史-->
<template>
  <div class="page_content">
    <!-- <subComponents ref="showSelectData"></subComponents> -->
    <processAuditAction ref="processAuditAction"></processAuditAction>
    <el-drawer
      :close-on-press-escape="true"
      :visible.sync="showStatus"
      :with-header="false"
      append-to-bodycustom-class="drawer_box"
      direction="ltr"
      size="100%"
    >
      <!-- 促销赠送 -->
      <cxGiftsAction
        v-if="showStatus"
        ref="cxGiftsAction"
        @drawerCancel="drawerCancel"
        @toDetail="toDetail"
        :actionData="actionData"
      ></cxGiftsAction>
    </el-drawer>
    <el-drawer
      :close-on-press-escape="true"
      :visible.sync="showStatusII"
      :with-header="false"
      append-to-bodycustom-class="drawer_box"
      direction="ltr"
      size="100%"
    >
      <!-- 促销调价 -->
      <cxAdjustmentActionII
        v-if="showStatusII"
        ref="cxAdjustmentActionII"
        @drawerCancel="drawerCancel"
        @toDetail="toDetail"
        :actionData="actionData"
      ></cxAdjustmentActionII>
    </el-drawer>
    <el-drawer
      :close-on-press-escape="true"
      :visible.sync="showStatusIII"
      :with-header="false"
      append-to-bodycustom-class="drawer_box"
      direction="ltr"
      size="100%"
    >
      <!-- 超量促销 -->
      <cxExcessAction
        v-if="showStatusIII"
        ref="cxExcessAction"
        @drawerCancel="drawerCancel"
        @toDetail="toDetail"
        :actionData="actionData"
      ></cxExcessAction>
    </el-drawer>
    <div class="page_content_top">
      <v-button
        :buttonList="buttonList"
        @actionSet="actionSet"
        :buttonFlag="false"
        @getPageInfo="getPageInfo"
        @openFormDesign="openFormDesign"
      ></v-button>
      <div class="page_content_top_line">
        <v-search
          :searchList="searchList"
          :getRequestData="getRequestData"
          @searchData="searchData"
          @openSearch="openSearch"
        ></v-search>
      </div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <div class="page_content_center" style="width: 100%">
        <el-table
          :key="tableFlag"
          stripe
          @row-click="storePriceClick"
          :data="returnData.list"
          :height="tableHeight"
          border
          style="width: 100%"
          highlight-current-row
          size="mini"
        >
          <!-- 主信息 -->

          <el-table-column header-align="center" label="选择操作" width="80">
            <template slot-scope="scope">
              <el-radio
                v-model="selectedRowIndex"
                :label="scope.$index"
                border
                size="mini"
                @change="handleRadioChange(scope.row, scope.$index)"
              >
                <i class="el-icon-thumb"></i>
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(tableValye, tableKey) in pageShowData"
            :key="tableKey"
            align="center"
            :prop="tableValye.entityField"
            :label="tableValye.showField"
            show-overflow-tooltip
            :min-width="tableValye.fieldWeight"
            :fixed="tableValye.fixed || false"
          >
            <template slot-scope="scope">
              <span v-if="tableValye.entityField == 'startDate'">
                <span v-if="scope.row[tableValye.entityField]">
                  {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                </span>
              </span>
              <span v-else-if="tableValye.entityField == 'endDate'">
                <span v-if="scope.row[tableValye.entityField]">
                  {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                </span>
              </span>
              <span v-else-if="tableValye.entityField == 'showType'">
                {{
                  scope.row.showType == 11
                    ? "特价促销"
                    : scope.row.showType == 12
                    ? "超量促销"
                    : scope.row.showType == 13
                    ? "买赠促销"
                    : scope.row.showType == 14
                    ? "整单促销"
                    : scope.row.showType == 15
                    ? "系列促销"
                    : scope.row.showType == 16
                    ? "积分促销"
                    : "未知"
                }}
              </span>
              <span v-else-if="tableValye.entityField == 'state'">
                <!-- 方案状态（-1：审核驳回、0：初始、1：提交、2：审核通过） -->
                <el-tag
                  :type="
                    scope.row.state == -1
                      ? 'danger'
                      : scope.row.state == 0
                      ? 'info'
                      : scope.row.state == 1
                      ? 'primary'
                      : 'success'
                  "
                >
                  {{
                    scope.row.state == -1
                      ? "审核驳回"
                      : scope.row.state == 0
                      ? "初始"
                      : scope.row.state == 1
                      ? "提交"
                      : "审核通过"
                  }}
                </el-tag>
              </span>
              <span v-else-if="tableValye.entityField == 'isEnable'">
                <el-tag
                  :type="
                    scope.row.isEnable == 0
                      ? 'danger'
                      : scope.row.isEnable == 1
                      ? 'success'
                      : 'info'
                  "
                >
                  {{
                    scope.row.isEnable == 0
                      ? "禁用"
                      : scope.row.isEnable == 1
                      ? "启用"
                      : "初始"
                  }}
                </el-tag>
              </span>
              <span v-else-if="tableValye.entityField == 'dayStartTime'">
                {{ formatTimeOnly(scope.row.dayStartTime) }}
              </span>

              <span v-else-if="tableValye.entityField == 'planId'">
                <a @click="toOpenPlanDetail(scope.row)">{{
                  scope.row.planId
                }}</a>
              </span>
              <span v-else-if="tableValye.entityField == 'dayEndTime'">
                {{ formatTimeOnly(scope.row.dayEndTime) }}
              </span>

              <span v-else-if="tableValye.entityField == 'round'">
                {{ scope.row.round }}
              </span>
              <span v-else>{{ scope.row[tableValye.entityField] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page_content_bottom">
      <v-pagination
        :page="getRequestData.page"
        :rows="getRequestData.rows"
        :total="returnData.total"
        @setDataPageSize="setDataPageSize"
        @setDataPageNumber="setDataPageNumber"
      ></v-pagination>
    </div>
    <!-- 检索方案 -->
    <el-dialog
      :title="seTitle"
      v-if="DialogVisible"
      :visible.sync="DialogVisible"
      :width="seWidth"
      :modal-append-to-body="true"
      :append-to-body="true"
      @close="closeChild"
    >
      <SearchScheme
        ref="searchScheme"
        :id="seId"
        :parentSearchData="parentSearchData"
        @TranData="changeInputModel"
        @getWidth="getSeWidth"
        @sendTitle="getSearchName"
      />
    </el-dialog>
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../../byComponents/SearchScheme.vue";
import { nameList, searchList } from "./cxHistList.js";
import cxAdjustmentActionII from "@/components/cxAdjustmentActionII.vue"
import cxExcessAction from "@/components/cxExcessAction.vue"
import cxGiftsAction from "@/components/cxGiftsAction.vue"
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    cxAdjustmentActionII,
    cxExcessAction,
    cxGiftsAction
  },
  data() {
    //这里存放数据
    return {
      sField: "",
      exTitle: "",
      exWidth: "",
      searchList: searchList,
      getRequestData: {
        businessId: "",
        creater: 0,
        end: "",
        ormId: 0,
        page: 1,
        planName: "",
        planType: "",
        reviewerCondition: "",
        rows: 30,
        start: "",
        stateList: [],
        taskIds: [],
      },

      //---------------
      seTitle: "",
      DialogVisible: false,
      seId: "",
      setField: "",
      setType: "",
      seWidth: "0",
      parentSearchData: {},
      //---------------
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },

      buttonList: [],
      multipleSelection: [],
      pageShowData: {},
      pageShowPeopleData: {},
      tableFlag: 0,
      selectedDataIndex: 0,
      planIds: "",
      tableHeight: 0,
      showStatus: false,
      showStatusII: false,
      showStatusIII: false,
      actionData: {},
      loading: false,
      selectedRowIndex: null,
      priceGroupForm: {
        bgmName: "",
        bgmId: "",
        price: "",
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.smName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.pspmBuycus = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    formatTimeOnly(val) {
      if (val == 0) {
        return "00:00:00";
      }
      if (!val) return "";

      // 直接将秒数转换为时分秒
      const totalSeconds = Number(val);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      // 补零
      const h = hours.toString().padStart(2, "0");
      const m = minutes.toString().padStart(2, "0");
      const s = seconds.toString().padStart(2, "0");

      return `${h}:${m}:${s}`;
    },
    // 子组件触发
    drawerCancel(e) {
      console.log(e, "+++++++++");
      this.showStatus = false;
      this.showStatusII = false;
      this.showStatusIII = false;
      if (e == 1) {
        this.getPageInfo();
      }
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage(
          {
            //向窗口发送MessageEvent消息
            cmd: "returnFormJson",
            params: {
              isPenetrate,
            }, //参数
          },
          "*"
        );
      }
      this.getPageInfo();
    },
    async toOpenPlanDetail(row) {
      console.log(row, "+++++++++");
      try {
        // 获取商品详情内容
        let responseData = await this.$http.getPlanDetail({
          ids: [row.planId],
        });
        console.log(responseData, "responseData");
        if (responseData.status == 200) {
          row.storeList = responseData.result.storeList
            ? responseData.result.storeList
            : [];

          row.mcTypeList = responseData.result.mcTypeList
            ? responseData.result.mcTypeList
            : [];
          if (row.planType == 1) {
            row.conBgmList = responseData.result.conBgmList
              ? responseData.result.conBgmList
              : [];
            row.giftBgmList = responseData.result.giftBgmList
              ? responseData.result.giftBgmList
              : [];
            row.conBgmTypeList = responseData.result.conBgmTypeList
              ? responseData.result.conBgmTypeList
              : [];
            row.giftYhqList = responseData.result.giftYhqList
              ? responseData.result.giftYhqList
              : [];
            row.banBgmList = responseData.result.banBgmList
              ? responseData.result.banBgmList
              : [];
            this.showStatus = true;
          } else if (row.planType == 2) {
            row.tjList = responseData.result.tjList
              ? responseData.result.tjList
              : [];
            this.showStatusII = true;
          } else if (row.planType == 3) {
            row.clList = responseData.result.clList
              ? responseData.result.clList
              : [];
            this.showStatusIII = true;
          }
          this.actionData = {
            cate: 1,
            formData: [],
            oldData: row,
            checkDisabled: true,
          };
        }
      } catch (error) {
        console.log(error, "error");
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path);

      this.$refs["customDesign"].openBox(
        pathInfo.jurId,
        this.pageShowData,
        pathInfo.jurName
      );
    },
    storePriceClick(row) {
      this.planIds = row.planId;
      this.selectedRowIndex = this.returnData.list.findIndex(
        (item) => item.planId === row.planId
      );
      this.multipleSelection = []; // 切换行时清空门店选择
    },

    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.seId = sId; //检索方案Id
      this.sField = sField; //赋值字段
      this.DialogVisible = true; //判断是否打开弹框
      this.seType = type;
    },
    //检索方案返回的数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val); //赋值字段，赋值
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.priceGroupForm[item] = val[item];
      });
    },
    //关闭提取、检索方案弹框关闭 创建键盘事件
    closeChild() {
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },

    getSeWidth(e) {
      console.log(e);
      this.seWidth = e + "%";
    },
    getWidth(e) {
      console.log(e);
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      console.log(e);
      this.seTitle = e;
    },

    // 获取数据列表
    async getPageInfo() {
      this.pageShowData = JSON.parse(JSON.stringify(nameList));

      let res = await this.$http.getPlanListHistory(this.getRequestData);
      if (res.status == 200) {
        this.returnData.list = res.result.list;
        this.returnData.total = res.result.total;
        this.returnData.pageNum = res.result.pageNum;
        this.returnData.pages = res.result.pages;
        this.selectedDataIndex = 0;
        if (this.returnData.list.length > 0) {
          this.planIds = this.returnData.list[0].planId;

          this.$nextTick(() => {
            if (this.returnData.list.length > 0) {
              this.selectedRowIndex = 0;
              this.multipleSelection = [this.returnData.list[0]];
            }
          });
        } else {
          this.BindList = [];
        }
      } else {
        this.$message({
          message: res.message,
          type: "error",
        });
      }
    },

    // 动作集合
    async actionSet(actionData) {
      console.log(actionData.actionType);
      if (this.returnData.list == null || this.returnData.list.length <= 0) {
        this.$message({
          message: "暂无数据",
          type: "error",
        });
        return false;
      }

      switch (actionData.actionType) {
        case 5:
          this.$refs["processAuditAction"].openBox(
            1,
            this.returnData.list[this.selectedRowIndex].planId
          );
          break;
        case 6:
     
            //    禁用方案
            this.$http
              .sellPlanUpdateState({
                id: this.returnData.list[this.selectedRowIndex].planId,
                isEnable: 0,
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$message({
                    message: "禁用成功",
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }
                this.getPageInfo();
              });
       
          break;
        case 7:
  
            this.$http
              .sellPlanUpdateState({
                id: this.returnData.list[this.selectedRowIndex].planId,
                isEnable: 1,
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$message({
                    message: "启用成功",
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }
                this.getPageInfo();
              });
       
          break;
        case 8:
          // 促销回退
          this.sellPlanRollBack();
          break;
        case 9:
          this.exportData()
          break
      }
    },

    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },

    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表 方案
    async getDataList() {
      let responseData = await this.$http.getPlanListHistory(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.returnData.pages = responseData.result.pages;
        this.selectedDataIndex = 0;

        if (this.returnData.list.length > 0) {
          this.planIds = this.returnData.list[0].planId;
          this.$nextTick(() => {
            if (this.returnData.list.length > 0) {
              this.selectedRowIndex = 0;
              this.multipleSelection = [this.returnData.list[0]];
            }
          });
        }
        this.$nextTick(() => {
          this.tableHeight = this.$common.getTableHeight();
          this.tableFlag++;
        });
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 删除数据
    delDataAction() {
      if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }

      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var delData = {
            ids: [this.returnData.list[this.selectedRowIndex].planId],
          };
          let responseData = await this.$http.delSellPlan(delData);
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });

            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => {});
    },
    sellPlanRollBack() {
      if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }

      //   促销回退
      this.$http.sellPlanRollBack({
        businessKey: this.returnData.list[this.selectedRowIndex].planId,
      }).then(res=>{
        if(res.status==200){
          this.$message({
            message: "回退成功",
            type: "success",
          });
          this.getDataList();
        }else{
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton();
    },
    //获取requesUrl的根路径
    getRequestUrl() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
    },

    handleRadioChange(row, index) {
      this.selectedRowIndex = index;
      this.planIds = row.id;
    },
    //导出数据
    exportData() {
      window.location.href = this.requesUrl + '/sellPlan/exportPlanListHistory?ormId=' + String(this.ormId) + '&planName=' + this.getRequestData.planName
         + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
         + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows
         + '&planType=' + (this.getRequestData.planType || '') + '&isEnable=' + (this.getRequestData.isEnable || '')
         + '&showType=' + (this.getRequestData.showType || '')
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.ormId = sessionStorage.getItem('ormId');
    this.getPageInfo();
    this.getButtonList();
    this.getRequestUrl();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$common.getTableHeight();
      this.tableFlag++;
    });
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = this.$common.getTableHeight();
    });
  }, //生命周期 - 更新之后
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}

.btns {
  display: flex;
  position: absolute;
  z-index: 999;
  padding-left: 10px;
  padding-top: 2px;
}

::v-deep.xunjia tr {
  height: 39px !important;
}

::v-deep.xunjia .el-button {
  font-size: 12px;
  padding: 5px 10px;
}

::v-deep.xunjia .el-button--danger {
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;
}

::v-deep.xunjia .el-button--danger:hover {
  color: #fff;
  background-color: #f78989;
  border-color: #f78989;
}

::v-deep.xunjia .el-table__fixed-right {
  height: 100% !important;
  position: absolute;
  top: 0;
  overflow: hidden;
  background-color: #fff;
  z-index: 3;
}

::v-deep.xunjia .el-table__fixed-right-patch {
  background-color: #fff;
}
</style>

